<template lang="html">
  <table-template
    ref="list-template"
    :hasSearch="false"
    actionUrl="lcwpbusiness/selectRechargeOrderList.action"
    :queryParams="queryParams">

    <template slot="search">

      <el-date-picker
              @change="onCreateTimeChanged"
              style="width:350px"
              clearable
              end-placeholder="创建截止"
              range-separator="-"
              start-placeholder="创建开始"
              type="datetimerange"
              v-model="createTimeSearch">
      </el-date-picker>

      <el-input style="margin-left: 10px;width: 200px;" v-model="queryParams.keyword" placeholder="商家名称/手机号"></el-input>
      <el-button style="margin-left: 10px;" type="primary" @click="$refs['list-template'].search()">搜索</el-button>
      <el-button @click="exportRechargeOrder()" style="margin-left: 10px" type="danger">导出</el-button>
    </template>

    <template slot="item" scope="scope">

    <el-table-column label="订单号" >
      <template scope="scope">
        {{scope.row.orderNumber}}
      </template>
    </el-table-column>
      <el-table-column label="姓名" >
        <template scope="scope">
          {{scope.row.personName}}
        </template>
      </el-table-column>
      <el-table-column prop="personPhone" label="手机号" >
      </el-table-column>
      <el-table-column prop="businessName" label="商家名">
      </el-table-column>
      <el-table-column  prop="count" label="充值云豆(粒)">

      </el-table-column>
      <el-table-column label="支付金额(元)" >
        <template scope="scope">
          {{scope.row.totalMoney/100}} 元
        </template>
      </el-table-column>
      <el-table-column label="支付状态" >
        <template scope="scope">
          <p v-bind:style="{color:payStatusColor(scope.row.payStatus)}">{{scope.row.payStatus | payStatusFilter}}  </p>
        </template>
      </el-table-column>

      <el-table-column label="支付时间" width="200">
        <template scope="scope">
          {{scope.row.payTime | dateTimeFormat}}
        </template>

      </el-table-column>

      <el-table-column label="创建时间" width="200">
        <template scope="scope">
          {{scope.row.createTime | dateTimeFormat}}
        </template>

      </el-table-column>

    </template>
  </table-template>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import Config from '@/framework/configs/Config'
import BasicPager from '@/mixins/BasicPager'
import channelSelect from '@/components/channelSelect'
export default {
  name: 'goods-list',
  extends: BasicPager,
  data: function () {
    return {
      createTimeSearch: null,
      queryParams: {
        channelId: null,
        pageNum: 1,
        pageSize: 20

      },
      isAdmin: false,
      imageUrl: Config.imageUrl
    }
  },
  filters: {

    payStatusFilter: function (value) {
      // 1-待支付；2-支付成功;3-支付失败;4-支付关闭;5-转入退款;6-取消支付;7-支付中
      let str = ''
      switch (value) {
        case 1:
          str = '待支付'
          break
        case 2:
          str = '支付成功'
          break
        case 3:
          str = '支付失败'
          break
        case 4:
          str = '支付关闭'
          break
        case 5:
          str = '转入退款'
          break
        case 6:
          str = '取消支付'
          break
        case 7:
          str = '支付中'
          break
        default:
          str = '无'
      }
      return str
    }
  },
  components: {
    TableTemplate,
    channelSelect
  },
  props: {
    type: {
      type: String,
      default: null
    },
    businessId: {
      type: Number,
      default: null
    }
  },
  created: function () {
    let loginInfo = this.getLoginInfo()
    if (loginInfo.loginPath === 'channel') {
      this.queryParams.channelId = loginInfo.id
    }
  },
  methods: {
    onCreateTimeChanged (datetime) {
      if (!datetime || datetime[0] == null) {
        this.queryParams.createTimeSearchStart = null
        this.queryParams.createTimeSearchEnd = null
        this.$refs['list-template'].search()
        return
      }
      this.queryParams.createTimeSearchStart = datetime[0].getTime()
      this.queryParams.createTimeSearchEnd = datetime[1].getTime()
      this.$refs['list-template'].search()
    },
    payStatusColor: function (payStatus) {
      let color = ''
      switch (payStatus) {
        case 1:
          color = '#909399'
          break
        case 2:
          color = '#67C23A'
          break
        case 3:
          color = '#F56C6C'
          break
        case 4:
          color = '#F56C6C'
          break
        case 5:
          color = '#F56C6C'
          break
        case 6:
          color = '#F56C6C'
          break
        default:
      }
      return color
    },
    exportRechargeOrder: function () {
      let _this = this

      let userInfo = _this.getLoginInfo()
      let loginPath = userInfo.loginPath
      let id = null
      if (userInfo.id) {
        id = userInfo.id
      } else if (userInfo.employeeId) {
        id = userInfo.employeeId
      }

      let dataStr = '&channelId=' + id

      if (this.queryParams.createTimeSearchStart) {
        dataStr += '&createTimeSearchStart=' + this.queryParams.createTimeSearchStart
      }

      if (this.queryParams.createTimeSearchEnd) {
        dataStr += '&createTimeSearchEnd=' + this.queryParams.createTimeSearchEnd
      }

      if (this.queryParams.keyword) {
        dataStr += '&keyword=' + this.queryParams.keyword
      }

      window.location.href = Config.baseUrl + '/lcwpbusiness/exportRechargeOrder.action?token=' + userInfo.token + '&loginAccountId=' + id + '&loginPath=' + loginPath + dataStr
    }

  }
}
</script>

<style lang="css" scoped>
</style>
